<div class="w-full max-w-md">
  <div class="rounded-t-xl px-4 py-3 flex items-center gap-3" [ngClass]="headerClasses">
    <mat-icon class="!w-fit !h-fit">{{ headerIcon }}</mat-icon>
    <h2 class="text-base font-semibold">
      {{ title | translate }}
    </h2>
  </div>

  <div class="bg-white rounded-b-xl p-4">
    @if (description) {
      <p class="text-sm text-neutral-700">
        {{ description | translate }}
      </p>
    }

    <div class="mt-6 flex justify-end gap-3">
      <button type="button" ctrButton variant="outlined" (click)="onCancel()">
        {{ cancelTextKey | translate }}
      </button>
      <button type="button" ctrButton (click)="onConfirm()">
        {{ confirmTextKey | translate }}
      </button>
    </div>
  </div>
</div>
